export default class UrlUtils{
  static normalize (str) {
    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, '://');

    // remove consecutive slashes
    str = str.replace(/([^:\s])\/+/g, '$1/');

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
  }

  static urlJoin() {
    let input = arguments;
    let options = {};

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
      options = arguments[1] || {};
    }

    let joined = [].slice.call(input, 0).join('/');
    return this.normalize(joined, options);
  }

  static addQueryParams(url, keyValues) {
    Object.entries(keyValues).forEach(([key, value]) => {
      url = this.addQueryParam(url, key, value);
    });

    return url;
  }

  static addQueryParam(url, name, value) {
    //https://stackoverflow.com/a/6021027
    var i = url.indexOf('#');
    var hash = i === -1 ? ''  : url.substr(i);
          url = i === -1 ? url : url.substr(0, i);

    var re = new RegExp("([?&])" + name + "=.*?(&|$)", "i");
    var separator = url.indexOf('?') !== -1 ? "&" : "?";
    if (url.match(re)) {
        url = url.replace(re, '$1' + name + "=" + value + '$2');
    } else {
        url = url + separator + name + "=" + value;
    }
    return url + hash;
  }
}

export function turnIntoRelative(absoluteUrl) {
  const parsedUrl = new URL(absoluteUrl)
  return parsedUrl.pathname + parsedUrl.search
}
